import { useEffect, useState } from 'react'
import { WellYieldCalculatedStringFields } from '../../../../types/form-types'
import { useGetWellData } from '../../../hooks/use-api'
import { useWellId } from '../../../hooks/use-well-id'
import { Card, FormField, Heading, ReadOnlyField } from '@msaf/core-react'

interface YieldCalculationsCardProps {
  isRefreshCalculation: boolean
  setIsRefreshCalculation: React.Dispatch<React.SetStateAction<boolean>>
}

export default function YieldCalculationsCard({
  isRefreshCalculation,
  setIsRefreshCalculation,
}: YieldCalculationsCardProps) {
  const id = useWellId()
  const [fields, setFields] = useState<Partial<WellYieldCalculatedStringFields>>({})
  const url = `wells/${id}/drilling-tests/calculation`

  const { isLoading, isSuccess, data, refetch } = useGetWellData(url)

  useEffect(() => {
    isRefreshCalculation && refetch()
  }, [isRefreshCalculation, refetch])

  useEffect(() => {
    if (isSuccess && data?.state) {
      setFields(data.state)
      setIsRefreshCalculation(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess, data?.state])

  return (
    <Card>
      <Heading level={3}>Calculations</Heading>
      <FormField isSkeleton={isLoading} labelId='specificCapacityId' label='Specific capacity (l/s/m)'>
        <ReadOnlyField
          isSkeleton={isLoading}
          labelledBy='specificCapacityId'
          value={`${fields?.specificCapacity ?? ''}`}
        />
      </FormField>

      <FormField isSkeleton={isLoading} labelId='maximumTestedYieldId' label='Maximum tested yield (l/s)'>
        <ReadOnlyField
          isSkeleton={isLoading}
          labelledBy='maximumTestedYieldId'
          value={`${fields?.maximumYield ?? ''}`}
        />
      </FormField>

      <FormField
        isSkeleton={isLoading}
        labelId='drawdownMaximumTestedYieldId'
        label='Drawdown at maximum tested yield (m)'
      >
        <ReadOnlyField
          isSkeleton={isLoading}
          labelledBy='drawdownMaximumTestedYieldId'
          value={`${fields?.drawdownAtMaxYield ?? ''}`}
        />
      </FormField>
    </Card>
  )
}
